export const KEY = {
  ACCESS_TOKEN: 'token',
  REFRESH_TOKEN: 'refreshToken',
  USERNAME: 'username',
  PASSWORD: 'password',
  ROOM_ENV: 'roomEnv',
  LOCALE_CODE: 'localeCode',
  REPORT_LAYOUT: 'reportLayout',
  FOLDER_VIEW: 'folderView',
  SSO_REQUEST: 'ssoRequest',
} as const;
